import { __rest } from "tslib";
import { translateFontCSS } from 'shared/utils/fonts';
import { mouseEventProps } from '../../mouseEventProps';
import { applyAttributeStyles } from '../../symbolUtils';
import { calculateOverflowFreeScale } from '../calculateOverflowFreeScale';
import { textAttributeStyleMap } from '../Text';
/**
 * Build the class names for the AnimatableDiv container.
 */
export const calcClasses = (props, scale = 1) => {
    const { conditionalState, symbol } = props;
    const possibleWarningClassName = conditionalState.attributes.autoFill !== 'yes' && scale !== 1
        ? 'symbol-warning'
        : '';
    return [symbol.id, conditionalState.id, possibleWarningClassName].join(' ');
};
/**
 * Calculate scale for overflowed text in the symbol boundary
 */
export const calcTextScale = (element, dependencies) => {
    const { styles, attributes } = dependencies.conditionalState;
    const { padding } = styles, otherStyles = __rest(styles, ["padding"]);
    const fontFamily = translateFontCSS(styles.fontFamily, attributes.fontFallback);
    const scale = calculateOverflowFreeScale(element, Object.assign(Object.assign({}, otherStyles), { fontFamily }), attributes.autoFill);
    return scale;
};
/**
 * Calculate styles (without Position styles) for Text symbol.
 */
export const calcTextStyles = (props, scale) => {
    const { conditionalState, hoverAnimation, inEditor, symbol } = props;
    const { mouseEventStyles } = mouseEventProps(symbol, inEditor, hoverAnimation);
    const { attributes, styles } = conditionalState;
    const { padding } = styles, otherStyles = __rest(styles, ["padding"]);
    const attributeStyles = applyAttributeStyles(attributes, textAttributeStyleMap);
    // Offset padding to account for letter-spacing
    const offsetPadding = calculatePaddingOffset(styles);
    // Calculate the possibly scaled fontSize.
    const fontSize = styles.fontSize;
    const computedFontSize = [1, undefined].indexOf(scale) !== -1
        ? fontSize
        : `${parseFloat(fontSize) * scale}vw`;
    // If we aren't in editor, don't display until overflow-free scale has been calculated.
    // We always display in-editor, so that the node is available to Moveable. Our primary
    // goal is to avoid Cumulative Layout shifts in the deliverable.
    const shouldDisplay = inEditor || scale !== undefined;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, mouseEventStyles), otherStyles), attributeStyles), { display: shouldDisplay ? 'flex' : 'none', fontSize: computedFontSize, fontFamily: translateFontCSS(styles.fontFamily, attributes.fontFallback), padding: offsetPadding, userSelect: 'none' });
};
/**
 * Determine padding offsets to account for letter-spacing.
 */
export const calculatePaddingOffset = (styles) => {
    const { letterSpacing, padding } = styles;
    if (['0px', undefined].indexOf(letterSpacing) !== -1) {
        return padding;
    }
    const paddingLeft = `calc(${padding} + ${letterSpacing})`;
    return `${padding} ${padding} ${padding} ${paddingLeft}`;
};
